"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
exports.theme = {
    breakpoints: {},
    colors: {
        background: {
            gray: "#F4F4F4",
            white: "#FFFFFF",
        },
        black: "#000000",
        blue: {
            300: "#94C5FC",
            500: "#4386F4",
            700: "#1F4FD6",
        },
        gray: {
            100: "#AFAFAF",
            400: "#686868",
            300: "#515151",
            500: "#282828",
            700: "#1A1A1A",
        },
        green: {
            300: "#00c76a",
            500: "#027A48",
            700: "#00381f",
        },
        pink: {
            300: "#FF9FAC",
            500: "#FF385C",
            700: "#C80839",
        },
        white: "#FFFFFF",
    },
    fonts: {
        inter: "Inter, sans-serif",
    },
};
